export default __webpack_public_path__ + "media/images/ui-icons_72a7cf_256x240-26901adab4b9797711e41a6a64491449.png";